import React from 'react';
import { motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
import { problems } from '../data/problems';
export function ProblemSection() {
  return <section className="bg-stage py-16 sm:py-20" aria-labelledby="problem-title" data-id="element-199" data-mp="30h7kvn5mjqti">
      <div className="mx-auto max-w-4xl px-4" data-id="element-200" data-mp="30jaml4g538e2">
        <div className="text-center" data-id="element-201" data-mp="2vq7nkgslf6qh">
          <p className="text-xs font-extrabold uppercase tracking-[.18em] text-gold" data-id="element-202" data-mp="2vp6euiz1uwbx">La realidad profesional</p>
          <h2 id="problem-title" className="mx-auto mt-3 max-w-3xl text-balance text-3xl font-extrabold leading-tight text-white sm:text-4xl" data-id="element-203" data-mp="39jyz1upvx0ou">
            ¿Cuántas clases más vas a preparar sobre Bibliotecología sin tener el material correcto?
          </h2>
          <p className="mx-auto mt-5 max-w-3xl leading-relaxed text-mutedDark" data-id="element-204" data-mp="3ei0jok2yl82f">
            Buscás información en internet que no tiene secuencia didáctica ni menciona la realidad de las bibliotecas
            argentinas. Armás planificaciones desde cero cada ciclo lectivo. Y cuando un alumno pregunta cómo clasificar un
            documento, qué dice la normativa IFLA sobre inclusión digital, cómo organizar una campaña de promoción de lectura con
            presupuesto mínimo en una escuela rural, cómo aplicar alfabetización informacional en contextos de brecha digital o
            qué hace realmente un bibliotecario en una institución pública argentina en 2026, no tenés una respuesta que los
            enganche con la realidad del campo bibliotecario argentino.
          </p>
          <p className="mt-4 font-bold text-gold" data-id="element-205" data-mp="171mvh2f2mmiz">No es falta de vocación profesional. Es que nadie armó el sistema completo para vos.</p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="panel-dark mt-9 rounded-2xl border border-violet p-6 sm:p-8" data-id="element-206" data-mp="1bzy5pe9a2z1q">
          <p className="mb-5 font-display text-xl font-bold text-mutedDark" data-id="element-207" data-mp="3hwka03ut57d7">Esto te está pasando ahora mismo:</p>
          <ul className="grid gap-4 sm:grid-cols-2" data-id="element-208" data-mp="k1flft00p7bq">
            {problems.map(item => <li key={item} className="flex gap-3 text-sm leading-relaxed text-onDark" data-id="element-209" data-mp="y0yv4q8h8qq5">
                <span className="mt-0.5 shrink-0 rounded-full bg-violet/50 p-1" data-id="element-210" data-mp="xym3tmgtx40f">
                  <XIcon className="h-3.5 w-3.5 text-mutedDark" data-id="element-211" data-mp="ty28moftgagx" />
                </span>
                {item}
              </li>)}
          </ul>
        </motion.div>

        <p className="mt-8 text-center font-bold text-gold" data-id="element-212" data-mp="12z8pwzqahpb8">
          ¿Y si esta fuera la última semana que enseñás Bibliotecología sin tener todo resuelto?
        </p>
      </div>
    </section>;
}